export class AboutRow {
  layout = 'imageLeft';
  title?: string;
  imageUrl?: string;
  imageAltText?: string;
  videoUrl?: string;
  borderRadius = false;
  html?: any;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/aboutRow.ts